import { render, staticRenderFns } from "./App.vue?vue&type=template&id=3f162b2d&scoped=true"
import script from "./App.vue?vue&type=script&lang=ts"
export * from "./App.vue?vue&type=script&lang=ts"
import style0 from "./App.vue?vue&type=style&index=0&id=3f162b2d&prod&lang=scss"
import style1 from "./App.vue?vue&type=style&index=1&id=3f162b2d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f162b2d",
  null
  
)

export default component.exports